import {transform, isEqual, isObject} from "lodash";

export function regexFromArray(array: Array<string>): RegExp {
    // @ts-ignore
    return new RegExp(...array.filter(v => !!v));
}

export function delayFrames(callable: Function, frames = 1): Function {
    return [...Array(frames + 1).keys()].reduce(
        prev => () => window.requestAnimationFrame(() => prev()),
        callable
    );
}

export function product(a: Array<any>, b: Array<any>): Array<any> {
    // @ts-ignore
    return [].concat(...a.map(av => b.map(bv => [av, bv])));
}

export function localeISODate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const days = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${days}T${hours}:${minutes}:${seconds}`;
}

export function difference(object: object, base: object): object {
    function changes(object: any, base: any): object {
        return transform(object, function (result: any, value: any, key: string | number) {
            if (!isEqual(value, base[key])) {
                result[key] = (isObject(value) && isObject(base[key]))
                    ? changes(value, base[key])
                    : value;
            }
        });
    }

    return changes(object, base);
}

export function parseSearchPath(): { [key: string]: string } {
    if (location.search.length === 0) return {};

    return location.search.substring(1)
        .split('&')
        .map(pair => pair.split('='))
        .reduce<{ [key: string]: string }>((acc, pair) => {
            acc[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            return acc;
        }, {});
}

export function no_null_filter(thing: any): boolean {
    return thing !== null
}

export function getMetaContent(name: string): string | null {
    return document.querySelector(`meta[name=${name}]`)?.getAttribute("content") || null;
}

export function array_wrap<T>(thing: T | Array<T>): Array<T> {
    return Array.isArray(thing)
        ? thing
        : [thing];
}

export function array_partition<T>(arr: Array<T>, fn: (val: T, idx: number, arr: Array<T>) => boolean): [Array<T>, Array<T>] {
    return arr.reduce(
        (acc, val, i, arr) => {
            acc[fn(val, i, arr) ? 0 : 1].push(val);
            return acc;
        },
        [[], []] as [Array<T>, Array<T>]
    );
}

export function genIsNotNullOrUndefined<T>(): (thing: any) => thing is T {
    return (thing: any): thing is T => thing !== null && thing !== undefined;
}

export const DS_VARIABLES_REG_EX = /\$\{(.+)\}/;

export function execDsVariablesRegEx(value: string) {
    return DS_VARIABLES_REG_EX.exec(value);
}
